var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Dialog, DialogMaxWidthSizes } from '../../../../../templates/dialog';
import { IconButtonStyles } from '../../../../../atoms/icon-button';
import { Iframe } from '../../../../../atoms/iframe';
var ZM = function (_a) {
    var props = __rest(_a, []);
    var background = props.background;
    var dialogProps = __assign(__assign({ fullWidth: true, fullScreen: true, dismissible: true, onClose: function () {
            var _a;
            props.setIsZoomModalOpen(false);
            props.setThumbsSliderZoom(null);
            (_a = props.setOpenZoomGallery) === null || _a === void 0 ? void 0 : _a.call(props, false);
        }, maxWidth: DialogMaxWidthSizes.MD, dialogContentPadding: false, closeButtonStyle: IconButtonStyles.DefaultDark }, (props.dialogCloseButtonAriaLabel
        ? { closeAriaLabel: props.dialogCloseButtonAriaLabel }
        : {})), { background: background });
    return (React.createElement(Dialog, __assign({}, __assign({ isOpen: props.isZoomModalOpen }, dialogProps)), props.children));
};
var VM = function (_a) {
    var props = __rest(_a, []);
    var dialogProps = __assign({ fullWidth: true, fullScreen: true, dismissible: true, 
        // eslint-disable-next-line  @typescript-eslint/no-explicit-any
        onClose: function (e) {
            var _a;
            e === null || e === void 0 ? void 0 : e.stopPropagation();
            (_a = props === null || props === void 0 ? void 0 : props.setIsOpen) === null || _a === void 0 ? void 0 : _a.call(props, false);
        }, maxWidth: DialogMaxWidthSizes.MD, dialogContentPadding: false, closeButtonStyle: IconButtonStyles.BasicDark }, (props.dialogCloseButtonAriaLabel
        ? { closeAriaLabel: props.dialogCloseButtonAriaLabel }
        : {}));
    var iframeConfig = __assign(__assign({ url: props.videoProps.videoSrc }, (props.videoProps.videoTitle !== ''
        ? { title: props.videoProps.videoTitle }
        : {})), { width: '100%', height: '100%', additionalParams: {
            allow: "sync-script 'none'; sync-xhr 'none'; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            referrerpolicy: 'strict-origin-when-cross-origin',
            style: { display: 'block' }
        } });
    return (React.createElement(Dialog, __assign({}, __assign({ isOpen: props.isOpen }, dialogProps)),
        React.createElement(Iframe, __assign({}, iframeConfig))));
};
export { ZM as ZoomModal, VM as VideoModal };
